import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../../src/types";
import { languages, checkLineCount, combineErrors, signatureInfo, size, getContentField } from "./shared";

const invitationText = 'Das Leben wird nach Jahren gezählt und nach Taten gemessen'


export const invitationTemplateData: CustomerTemplate = {
    key: 'invitation',
            name: {
                de: 'Einladungskarte',
                en: 'Invitation'
            },
            ...size,
            languages,
            signatureInfo: {
                maxSignatures: 1
            },
            templateData: [
                {
                    key: 'headlineTop',
                    name: {
                        en: 'Headline Top',
                        de: 'Überschrift obere Zeile'
                    },
                    languageData: {
                        'de': '50',
                        'en': '50'
                    },
                    maxLength: 3,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                {
                    key: 'headlineBottom',
                    name: {
                        en: 'Headline Bottom',
                        de: 'Überschrift untere Zeile'
                    },
                    languageData: {
                        'de': 'Jahre',
                        'en': 'Years'
                    },
                    maxLength: 5,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                {
                    key: 'subHeadline2',
                    name: {
                        en: 'Sub headline',
                        de: 'Untertitel'
                    },
                    languageData: {
                        'de': 'Einladung zum Geburtstag',
                        'en': 'Birthday invitation'
                    },
                    maxLength: 29,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                {
                    key: 'subHeadline3',
                    name: {
                        en: 'Sub headline',
                        de: 'Untertitel'
                    },
                    languageData: {
                        'de': '6. Mai 2021 | 20:00 Uhr',
                        'en': 'May 6, 2021 | 8:00 p.m.'
                    },
                    maxLength: 25,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                {
                    key: 'subHeadline4',
                    name: {
                        en: 'Sub headline',
                        de: 'Untertitel'
                    },
                    languageData: {
                        'de': 'Restaurant in Oldenburg',
                        'en': 'Restaurant in Oldenburg'
                    },
                    maxLength: 40,
                    hide: false,
                    isValid: combineErrors([checkLineCount(1)])
                },
                getContentField(invitationText)
            ],
            font: {
                doubleHeadline: false,
                headlineTop: {
                    family: 'Parisienne-Regular',
                    color: '#000', 
                    size: 225,
                    TopPadding: 270,
                    headMarginLeft: -60,
                    lineHeight: 10
                },
                headlineBottom: {
                    family: 'Parisienne-Regular',
                    color: '#fca103', 
                    size: 105,
                    TopPadding: 305,
                    headMarginRight: 96,
                    lineHeight: 0
                },
                content: {
                    family: 'Roboto-Light',
                    color: '#000', 
                    size: 22,
                    TopPadding: 395,
                    lineHeight: 20
                },
                subHeadline2: {
                    family: 'Roboto-Light',
                    color: '#000', 
                    size: 35,
                    TopPadding: 595,
                    yScale2: 20,
                    lineHeight: 20
                },
                doubleSubHeadline: true,
                subHeadline3: {
                    family: 'Roboto-Light',
                    color: '#000', 
                    size: 25,
                    TopPadding: 645,
                    yScale2: 20,
                    lineHeight: 35
                },
                subHeadline4: {
                    family: 'Roboto-Light',
                    color: '#000', 
                    size: 25,
                    TopPadding: 645,
                    yScale2: 20,
                    lineHeight: 35
                }
            },
            signature: {
                topPadding: 630,
                contentDep: true,
                singleSignature: true,
                fontSize: 40,
                fontSizeSub: 15,
                color: '#000'
            }
}